import { IStore } from '../index'

export const getContractsSendEmailValues = (state: IStore) =>
  state.clientContractsSendEmailReducer
